const articleCta = document.querySelector('.article__cta[data-scroll]');
const mobile = window.innerWidth < 768;

if (articleCta && mobile) {
  const handleScroll = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableHeight <= 0) {
      return;
    }

    const scrollPercentage = (window.scrollY / scrollableHeight) * 100;

    if (scrollPercentage > 20) {
      articleCta.classList.remove('hidden');
      window.removeEventListener('scroll', handleScroll);
    }
  };

  window.addEventListener('scroll', handleScroll);

  handleScroll();
}
